import classnames from 'classnames';


const { createHigherOrderComponent } = wp.compose;
const { __ } = wp.i18n;
const { Fragment, useEffect } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, SelectControl } = wp.components;

/**
 * Add custom attributes to the group block
 *
 * @param {Object} settings Current block settings
 * @param {string} name Block name
 *
 * @return {Object} Modified settings
 */
const groupActionsRegister = ( settings, name ) => {

	if ( name !== 'core/group' ) {

		return settings;

	}
	settings.attributes = Object.assign( settings.attributes, {
		hasRounded: {
			type: 'boolean',
			default: false,
		},
		roundedValue: {
			type: 'string',
			default: '',
		},
		sideSpaces: {
			type: 'boolean',
			default: false,
		},
		fullHeight: {
			type: 'boolean',
			default: false,
		},
		style: {
			type: 'object',
			default: {
				spacing: {
					padding: {
						top: 'var:preset|spacing|60',
						bottom: 'var:preset|spacing|60',
					},
				},
			}
		}
	} );


	return settings;

}


wp.hooks.addFilter(
	'blocks.registerBlockType',
	'wombat/group/register/custom/style',
	groupActionsRegister
);

const groupActionsEdit = createHigherOrderComponent( ( BlockEdit ) => {

	return ( props ) => {

		if ( props.name !== 'core/group' ) {

			return <BlockEdit {...props} />;

		}
		const { attributes, setAttributes } = props;
		const { hasRounded, sideSpaces, layout, fullHeight, roundedValue } = attributes


		useEffect( () => {

			if ( layout.type !== 'constrained' ) {

				setAttributes( { sideSpaces: false } )

			}

		}, [layout?.type, setAttributes] );

		return (
			<Fragment>
				<BlockEdit {...props} />
				<InspectorControls>
					<PanelBody title={__( 'Layout settings' )}>
						<ToggleControl
							label={__( 'Round corners' )}
							checked={hasRounded}
							onChange={() => setAttributes( { hasRounded: !hasRounded } )}
						/>
						{hasRounded && (
							<SelectControl
								label={__( 'Round size', 'wombat' )}
								value={roundedValue}
								options={[
									{ label: 'Default (35px)', value: '' },
									{ label: 'Small (16px)', value: 'small' },
								]}
								onChange={( newRoundedValue ) => setAttributes( { roundedValue: newRoundedValue } )}
							/>
						)}
						{layout?.type === 'constrained' && (
							<ToggleControl
								label={__( 'Spaces on the sides' )}
								checked={sideSpaces}
								onChange={() => setAttributes( { sideSpaces: !sideSpaces } )}
							/>
						)}
						<ToggleControl
							label={__( 'Full height' )}
							checked={fullHeight}
							onChange={() => setAttributes( { fullHeight: !fullHeight } )}
							help={'Sets the minimum height of the block to the full height of the screen'}
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
		);

	};

}, 'groupActionsEdit' );

wp.hooks.addFilter(
	'editor.BlockEdit',
	'wombat/group/edit/custom/style',
	groupActionsEdit
);

const groupActionsList = createHigherOrderComponent( ( BlockListBlock ) => {

	return ( props ) => {

		if ( props.name !== 'core/group' ) {

			return <BlockListBlock {...props} />;

		}
		const { className, attributes } = props;
		const { hasRounded, sideSpaces, fullHeight, roundedValue } = attributes

		return <BlockListBlock
			{...props}
			className={classnames(
				className,
				{ 'has-rounded': hasRounded },
				{ 'has-rounded--small': hasRounded && roundedValue.length > 0 },
				{ 'has-side-spaces': sideSpaces },
				{ 'has-full-height': fullHeight },
			)}
		/>;

	};

}, 'groupActionsList' );

wp.hooks.addFilter(
	'editor.BlockListBlock',
	'wombat/group/list/custom/style/',
	groupActionsList
);

/**
 * Saves the properties of an element based on the block type and attributes provided.
 *
 * @param {Object} saveElementProps - The properties of the element to be saved.
 * @param {string} blockType - The type of block the element belongs to.
 * @param {Object} attributes - Additional attributes related to the element.
 * @return {Object} The result of the save operation, typically including status and any updated properties.
 */
const groupActionsSave = ( saveElementProps, blockType, attributes ) => {


	if ( blockType.name !== 'core/group' ) {

		return saveElementProps;

	}

	const { hasRounded, sideSpaces, fullHeight, roundedValue } = attributes

	saveElementProps.className = classnames(
		saveElementProps.className,
		{ 'has-rounded': hasRounded },
		{ 'has-rounded--small': hasRounded && roundedValue.length > 0 },
		{ 'has-side-spaces': sideSpaces },
		{ 'has-full-height': fullHeight },
	);
	return saveElementProps;

};

wp.hooks.addFilter(
	'blocks.getSaveContent.extraProps',
	'wombat/group/save/custom/style',
	groupActionsSave
);
